<app-loader [hideSpinner]="isDataLoaded"></app-loader>
<nav [ngClass]="{ 'hidden': !isDataLoaded }" class="list-header navbar navbar-light bg-light">
  <span class="navbar-brand">Country List</span>
  <div class="navbar-nav mr-auto"></div>
  <button mat-stroked-button (click)="addCountry()">
    <mat-icon>add</mat-icon>
    <span>Add Country</span>
  </button>
</nav>
<div [ngClass]="{ 'hidden': !isDataLoaded }" class="list-container">
  <div class="filter-container">
    <mat-form-field>
      <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Filter">
    </mat-form-field>
  </div>
  <mat-table [dataSource]="dataSource" matSort matSortActive="Id" matSortDirection="asc">
    <ng-container matColumnDef="Id">
      <mat-header-cell *matHeaderCellDef mat-sort-header> ID </mat-header-cell>
      <mat-cell *matCellDef="let row"> {{row.id}} </mat-cell>
    </ng-container>

    <ng-container matColumnDef="Name">
      <mat-header-cell *matHeaderCellDef mat-sort-header> Country Name </mat-header-cell>
      <mat-cell *matCellDef="let row"> 
        <span>{{row.name}}</span>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="CountryCode">
      <mat-header-cell *matHeaderCellDef mat-sort-header> Country Code </mat-header-cell>
      <mat-cell *matCellDef="let row"> {{row.code}} </mat-cell>
	</ng-container>
	
    <ng-container matColumnDef="CurrencyCode">
      <mat-header-cell *matHeaderCellDef mat-sort-header> Currency Code </mat-header-cell>
      <mat-cell *matCellDef="let row"> {{row.currencyCode}} </mat-cell>
    </ng-container>

    <ng-container matColumnDef="formatActive">
      <mat-header-cell *matHeaderCellDef mat-sort-header> Status </mat-header-cell>
      <mat-cell *matCellDef="let row"> {{row.formatActive}} </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns;" (click)="viewCountry(row.id)"></mat-row>
  </mat-table>

  <mat-paginator [pageSizeOptions]="[10, 25, 50, 100]"></mat-paginator>
</div>